import { Theme } from '@core/enums';
import { ButtonTheme } from '@stories/Elements/Forms/Buttons/Button';
import { CheckboxTheme } from '@stories/Elements/Forms/Fields/Checkbox/Checkbox';
import { ErrorTextTheme } from '@stories/Elements/Forms/Fields/Form.styles';
import { SelectTheme } from '@stories/Elements/Forms/Fields/Select/SelectUnderline';
import { TextboxTheme } from '@stories/Elements/Forms/Fields/Textbox/Textbox';

export type FormFieldsTheme = {
  button: ButtonTheme;
  checkbox: CheckboxTheme;
  error: ErrorTextTheme;
  global: Theme;
  select: SelectTheme;
  textbox: TextboxTheme;
};

export const getFormFieldsTheme = (theme: Theme): FormFieldsTheme => {
  const formFieldsTheme: FormFieldsTheme = {
    button: 'black',
    checkbox: CheckboxTheme.White,
    error: 'black',
    global: theme,
    select: SelectTheme.Red_Base,
    textbox: TextboxTheme.Red_Base,
  };

  switch (theme) {
    case Theme.Black:
      formFieldsTheme.textbox = TextboxTheme.White;
      formFieldsTheme.select = SelectTheme.White;
      formFieldsTheme.checkbox = CheckboxTheme.White;
      formFieldsTheme.error = 'white';
      formFieldsTheme.button = 'red';
      break;

    case Theme.White:
      formFieldsTheme.textbox = TextboxTheme.Black;
      formFieldsTheme.select = SelectTheme.Black;
      formFieldsTheme.checkbox = CheckboxTheme.Black;
      formFieldsTheme.error = 'red';
      formFieldsTheme.button = 'black';

      break;

    default:
    case Theme.Red:
      formFieldsTheme.textbox = TextboxTheme.Red_Base;
      formFieldsTheme.select = SelectTheme.Red_Base;
      formFieldsTheme.checkbox = CheckboxTheme.White;
      formFieldsTheme.error = 'black';
      formFieldsTheme.button = 'black';
      break;
  }

  return formFieldsTheme;
};
